export interface SalesDespatchNoteForInvoice {
  id: string;
  despatchNoteNo: number;
  despatchDate: Date;
  orderNos: string;
  customerKey: string;
  customerName: string;
  deliveryAddress: string;
  notes: string;
}
